const DrhCoveoFields = {
	AutoComplete: { fieldName: "autocompletetez120xt" },
};

export default DrhCoveoFields;
